import { InputText } from 'primereact/inputtext';
import { ChangeEvent } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FieldErrorMessage } from '@features/campaigns/builder/components/FormFields/common/FieldErrorMessage/FieldErrorMessage.tsx';
import { FormFields } from '@features/users/adminPanel/components/FormFields/FieldTypes.ts';
import { FieldWrapper } from '@features/users/adminPanel/components/FormFields/FieldWrapper.tsx';
import { VAT_NUMBER_LENGTH } from '@features/users/adminPanel/consts/common.ts';
import { i18nNameSpace } from '@shared/consts/i18n.ts';

export function FieldVatNumber() {
  const { t } = useTranslation(i18nNameSpace.USERS);
  const { control } = useFormContext();

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>, onChange: (value: string) => void) => {
    const value = e.target.value.slice(0, VAT_NUMBER_LENGTH);
    onChange(value);
  };

  return (
    <FieldWrapper labelText={t('page.adminPanel.formFields.vatNumber.label')} fieldType={FormFields.VAT_NUMBER}>
      <Controller
        control={control}
        name={FormFields.VAT_NUMBER}
        render={({ field, formState: { errors } }) => {
          return (
            <>
              <InputText
                {...field}
                type='text'
                id={FormFields.VAT_NUMBER}
                placeholder={t('page.adminPanel.formFields.vatNumber.placeholder')}
                onChange={(e) => handleInputChange(e, field.onChange)}
              />
              {errors?.[FormFields.VAT_NUMBER] && (
                <FieldErrorMessage fieldErrorData={errors} fieldName={FormFields.VAT_NUMBER} />
              )}
            </>
          );
        }}
      />
    </FieldWrapper>
  );
}
